var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopVolumeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.666 33H30.666V39H34.666V33Z",
    fill: "#9FABCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 9V21H8.66602H7.66602V9H8.66602H11.666Z",
    fill: "#D2C7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 24H18.296C18.6348 25.0503 19.1088 26.052 19.706 26.98L19.666 27H14.666C13.0747 27 11.5486 26.3679 10.4234 25.2426C9.29816 24.1174 8.66602 22.5913 8.66602 21H11.666C11.666 21.7956 11.9821 22.5587 12.5447 23.1213C13.1073 23.6839 13.8704 24 14.666 24Z",
    fill: "#AE9AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 6V9H8.66602V3H17.666V6H11.666Z",
    fill: "#AE9AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.667 24C51.4626 24 52.2257 23.6839 52.7883 23.1213C53.3509 22.5587 53.667 21.7956 53.667 21H56.667C56.667 22.5913 56.0348 24.1174 54.9096 25.2426C53.7844 26.3679 52.2583 27 50.667 27H45.667L45.627 26.98C46.2242 26.052 46.6981 25.0503 47.037 24H50.667Z",
    fill: "#AE9AFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.666 3H56.666V9H53.666V6H47.666V3Z",
    fill: "#AE9AFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.036 24C46.6972 25.0503 46.2232 26.052 45.626 26.98C44.455 28.8262 42.8361 30.3462 40.9198 31.3988C39.0036 32.4513 36.8523 33.0021 34.666 33H30.666C28.4798 33.0021 26.3285 32.4513 24.4122 31.3988C22.496 30.3462 20.8771 28.8262 19.706 26.98C19.1088 26.052 18.6348 25.0503 18.296 24C17.8773 22.708 17.6647 21.3581 17.666 20V1H47.666V20C47.6674 21.3581 47.4548 22.708 47.036 24Z",
    fill: "#AF9AFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.666 1V20C43.6674 21.3581 43.4548 22.708 43.036 24C42.6972 25.0503 42.2232 26.052 41.626 26.98C40.455 28.8262 38.836 30.3462 36.9198 31.3988C35.0036 32.4513 32.8523 33.0021 30.666 33H34.666C36.8523 33.0021 39.0036 32.4513 40.9198 31.3988C42.836 30.3462 44.455 28.8262 45.626 26.98C46.2232 26.052 46.6972 25.0503 47.036 24C47.4548 22.708 47.6674 21.3581 47.666 20V1H43.666Z",
    fill: "#BBAAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.706 26.98C23.1088 26.052 22.6348 25.0503 22.296 24C21.8773 22.708 21.6647 21.3581 21.666 20V1H17.666V20C17.6647 21.3581 17.8773 22.708 18.296 24C18.6348 25.0503 19.1088 26.052 19.706 26.98C20.8771 28.8262 22.496 30.3462 24.4122 31.3988C26.3285 32.4513 28.4798 33.0021 30.666 33H34.666C32.4798 33.0021 30.3285 32.4513 28.4122 31.3988C26.496 30.3462 24.8771 28.8262 23.706 26.98Z",
    fill: "#937DEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.666 9V21H56.666H53.666V9H56.666H57.666Z",
    fill: "#D2C7FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.666 39H25.666V43H39.666V39Z",
    fill: "#92A5CB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.666 59V63H17.666V59H19.666H45.666H47.666Z",
    fill: "#937DEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.666 43L45.666 59H19.666L20.666 43H25.666H39.666H44.666Z",
    fill: "#937DEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.666 47L41.666 55H23.666L24.666 47H40.666Z",
    fill: "#BBAAFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.666 50H26.666V52H28.666V50Z",
    fill: "#9196AA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.666 50H30.666V52H38.666V50Z",
    fill: "#9196AA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.791 57L19.666 59H45.666L45.541 57H19.791Z",
    fill: "#6D58C1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.666 5C22.666 4.44772 22.2183 4 21.666 4C21.1137 4 20.666 4.44772 20.666 5C20.666 5.55228 21.1137 6 21.666 6C22.2183 6 22.666 5.55228 22.666 5Z",
    fill: "#FFECCF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.666 4H25.666C25.1137 4 24.666 4.44772 24.666 5C24.666 5.55228 25.1137 6 25.666 6H43.666C44.2183 6 44.666 5.55228 44.666 5C44.666 4.44772 44.2183 4 43.666 4Z",
    fill: "#FFECCF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.666 50H26.666V52H28.666V50Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.666 50H30.666V52H38.666V50Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.666 4H20.666V6H22.666V4Z",
    fill: "#4329AD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.666 4H24.666V6H44.666V4Z",
    fill: "#4329AD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopVolumeLight);
export default __webpack_public_path__ + "static/media/topVolumeLight.8bad9a604109ebf7b031c65b5c34d265.svg";
export { ForwardRef as ReactComponent };